export const NAV_OVERVIEW = "Overview";
export const NAV_DETAILS = "Details";
